module.exports = __webpack_public_path__ + "static/media/products.ec72899d.jpg";